import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Tiktok = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        d="M9.70529 17.3639C11.1515 17.3639 12.324 16.3284 12.324 14.7452V3H15.4645C15.2883 5.142 17.4177 7.21111 19.766 7.16379V10.1169C17.7577 10.1169 16.0499 9.26775 15.4555 8.79647V14.7452C15.4555 17.3639 13.3955 20.3333 9.70529 20.3333C6.0151 20.3333 4 17.3639 4 14.7452C4 11.0492 7.91131 8.90564 10.5018 9.42955V12.4375C10.3715 12.3914 10.0354 12.3232 9.74919 12.3232C8.29093 12.2695 7.08663 13.4522 7.08663 14.7452C7.08663 16.1914 8.25905 17.3639 9.70529 17.3639Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default Tiktok;
